const videoPlayer = ( $ ) => {

	$(".video-image-cta__video.video-player").on("click", function (event) {
		// removing image caption when video is played
		$(".video-image-cta__video--caption").remove();
		$(".video-image-cta__video").addClass("video--open");
		$(".video-player__video")[0].src += "?&autoplay=1";
		event.preventDefault();
	})

	$(".video-media__video.video-player").on("click", function (event) {
		$(".video-media__video").addClass("video--open");
		$(".video-player__video")[0].src += "?&autoplay=1";
		event.preventDefault();
	})
}

export default videoPlayer;
